/** Each tab is its own route, `/reference-data/<tab>`, so a breadcrumb or a reload lands on it. The first is where `/reference-data` redirects. */
export const REFERENCE_DATA_TABS = [
  'truck-classes',
  'trailer-types',
  'document-types',
  'job-types',
  'container-sizes',
  'container-types',
  'weight-bands',
  'reason-codes',
  'zone-kinds',
  'escalation-levels',
] as const;
export type ReferenceDataTab = (typeof REFERENCE_DATA_TABS)[number];

export const REFERENCE_DATA_TAB_LABELS: Record<ReferenceDataTab, string> = {
  'truck-classes': 'Truck classes',
  'trailer-types': 'Trailer types',
  'document-types': 'Document types',
  'job-types': 'Job types',
  'container-sizes': 'Container sizes',
  'container-types': 'Container types',
  'weight-bands': 'Weight bands',
  'reason-codes': 'Reason codes',
  'zone-kinds': 'Zone kinds',
  'escalation-levels': 'Escalation levels',
};

/** Tabs whose list endpoint is also open to `job.view`, so a 403 can't be what keeps them from someone without `configuration.manage`. */
export const CARGO_CATALOGUE_TABS: readonly ReferenceDataTab[] = ['container-sizes', 'container-types', 'weight-bands'];

export function referenceDataTabPath(tab: ReferenceDataTab): string {
  return `/reference-data/${tab}`;
}
